export type PermissionSubject = {
  isAdmin: boolean
  permissions?: string[]
  features?: string[]
}

/**
 * 이 배치에서 켜진 기능인가 (백엔드 core/features.py 의 단일 출처를 /auth/me 로 받는다).
 * - features 가 없으면(옛 백엔드) 전부 켜진 것으로 본다
 * - 관리자여도 꺼진 기능은 열리지 않는다(메뉴는 비활성으로 보인다) — 권한이 아니라 배치의 문제다
 */
export function hasFeature(subject: PermissionSubject, feature?: string): boolean {
  if (!feature) return true
  if (!subject.features) return true
  return subject.features.includes(feature)
}

/**
 * 전역 권한 코드 보유 여부 체크
 * - 관리자(isAdmin=true)는 항상 허용
 */
export function hasPermission(subject: PermissionSubject, code: string): boolean {
  if (!code) return true
  if (subject.isAdmin) return true
  const perms = subject.permissions ?? []
  return perms.includes(code)
}


